module.exports = __webpack_public_path__ + "static/media/scrum.a054c1a4.png";